/** Hash za skok na kontakt formu (KontaktPage — id="kontakt-form"). */
export const KONTAKT_FORM_HASH = 'kontakt-form';

/** Putanja za CTA „Javite nam se“ — otvara kontakt stranicu direktno na formi. */
export const KONTAKT_FORM_PATH = `/kontakt#${KONTAKT_FORM_HASH}`;
